// extracted by mini-css-extract-plugin
var _1 = "CarouselView__page--jId3m";
var _2 = "CarouselView__page2--zsFdi";
var _3 = "CarouselView__page3--SsRiy";
var _4 = "CarouselView__page4--ksIPu";
var _5 = "CarouselView__page5--wNTHB";
var _6 = "CarouselView__tempPageA--T8i_y CarouselView__page--jId3m";
var _7 = "CarouselView__tempPageB--HDhkG CarouselView__page--jId3m";
export { _1 as "page", _2 as "page2", _3 as "page3", _4 as "page4", _5 as "page5", _6 as "tempPageA", _7 as "tempPageB" }
